import React from 'react';

/**
 * Nav-bar trigger that opens the map overview video modal.
 *
 * Icon: a "?" inside a circle — the universal help glyph. Same sizing/border
 * language as ExportButton / QuickSaveButton so it sits cleanly in the
 * `.saved-searches-buttons` row.
 */
function HelpButton({ onClick, label = null }) {
  const tooltip = 'Watch the map overview video';

  return (
    <button
      className="help-button"
      onClick={onClick}
      title={tooltip}
      aria-label={tooltip}
    >
      <svg
        className="help-button__icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      {label && <span className="help-button__label">{label}</span>}
    </button>
  );
}

export default HelpButton;
